import { CompanyDetails, State } from '../types/profile';
import {
  CreditApplicationDetails,
  CreditApplicationStatusType,
  CreditFormData,
  PreferredMethodOfInvoicing,
} from '../types/credit';

export const mapCreditApplicationToFormData = (
  creditApplicationInfo: CreditApplicationDetails | null,
  companyDetails: CompanyDetails,
  states: State[],
): CreditFormData => {
  const stateOfOrganizationId = companyDetails?.current_company_contract?.company.org_state;
  const stateOfOrganizationName =
    states.find((state) => state.state_id === stateOfOrganizationId)?.name || companyDetails.home_office_location?.state?.name;
  const billingDetailsStateId =
    creditApplicationInfo?.billing_details?.billing_address_state_id ||
    companyDetails.billing_location?.state.state_id;
  const billingDetailsStateName =
    states.find((state) => state.state_id === billingDetailsStateId)?.name || states[0].name;

  const billingStreet = creditApplicationInfo?.billing_details?.billing_address_street_1 || '';
  const billingCity = creditApplicationInfo?.billing_details?.billing_address_city || '';
  const billingZip =
    creditApplicationInfo?.billing_details?.billing_address_zip_code?.toString() || '';

  // Get fallback values from company details
  const companyBillingStreet = companyDetails.billing_location?.street_1 || '';
  const companyBillingCity = companyDetails.billing_location?.city || '';
  const companyBillingZip = companyDetails.billing_location?.zip_code?.toString() || '';
  return {
    creditApplicationStatus: {
      id: creditApplicationInfo?.id || null,
      status: creditApplicationInfo?.status || CreditApplicationStatusType.NOT_STARTED,
      credit_limit: creditApplicationInfo?.credit_limit || null,
    },
    companyDetails: {
      businessLegalName: companyDetails?.name || '',
      dba: companyDetails?.doing_business_as || '',
      locationId: companyDetails.home_office_location_id || null,
      address: companyDetails.home_office_location?.street_1 || '',
      city: companyDetails.home_office_location?.city || '',
      state: companyDetails.home_office_location?.state?.name || '',
      zip: companyDetails.home_office_location?.zip_code?.toString() || '',
      federalTaxID: creditApplicationInfo?.company_details?.federal_tax_id || '',
      natureOfBusiness: companyDetails?.business_nature || '',
      stateOfOrganization: stateOfOrganizationName || '',
      contactName: creditApplicationInfo?.company_details?.contact_name || '',
      phone: creditApplicationInfo?.company_details?.contact_phone || '',
      email: creditApplicationInfo?.company_details?.contact_email || '',
      isSalesTaxExempt: creditApplicationInfo?.company_details?.is_sales_exempt ?? false,
      hasFiledBankruptcy: creditApplicationInfo?.company_details?.in_bankruptcy ?? false,
    },
    billingDetails: {
      accountsPayableFirstName:
        creditApplicationInfo?.billing_details?.account_payable_contact_first_name || '',
      accountsPayableLastName:
        creditApplicationInfo?.billing_details?.account_payable_contact_last_name || '',
      billingAddress:
        billingStreet === '' || billingStreet === null
          ? companyBillingStreet || ''
          : billingStreet || '',
      city:
        billingCity === '' || billingCity === null ? companyBillingCity || '' : billingCity || '',
      state: billingDetailsStateName || '',
      zip:
        billingZip === '' || billingZip === null || billingZip === '0'
          ? companyBillingZip || ''
          : billingZip || '',
      billingPhone: creditApplicationInfo?.billing_details?.billing_phone || '',
      billingEmail: creditApplicationInfo?.billing_details?.billing_email || '',
      preferredMethodOfInvoicing:
        creditApplicationInfo?.billing_details?.is_paperless_billing ||
        PreferredMethodOfInvoicing.EMAIL,
      isPORequired: creditApplicationInfo?.billing_details?.is_po_required ?? true,
      isMonthlyStatementsRequired:
        creditApplicationInfo?.billing_details?.disable_monthly_statements ?? true,
    },
    insuranceDetails: {
      haveMyOwnRentalInsurance: creditApplicationInfo?.insurance_details?.own_insurance ?? true,
      insuranceCompany: creditApplicationInfo?.insurance_details?.insurance_company || '',
      phone: creditApplicationInfo?.insurance_details?.insurance_phone || '',
      email: creditApplicationInfo?.insurance_details?.insurance_email || '',
    },
    dateSubmitted: creditApplicationInfo?.date_updated || '',
  };
};
